export var KEY_UP = 'ArrowUp';
export var KEY_DOWN = 'ArrowDown';
export var KEY_SPACE = ' ';
export var KEY_ENTER = 'Enter';
export var KEY_TAB = 'Tab';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/util/keys.js
// module id = 108
// module chunks = 0